// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".global-wrapper[data-v-0c8cb36c]{overflow-x:hidden}.global-wrapper .global-wrapper__content[data-v-0c8cb36c]{padding:168px 64px 0}@media (max-width:1439px){.global-wrapper .global-wrapper__content[data-v-0c8cb36c]{padding:126px 64px 0}}@media (max-width:767px){.global-wrapper .global-wrapper__content[data-v-0c8cb36c]{padding:101px 16px 0}}", ""]);
// Exports
module.exports = exports;
